import React from "react";
import {
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBCol,
    MDBContainer,
    MDBRow,
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import Logo from "../../components/images/StreamsAIWhite.png";
import LogoDark from "../../components/images/StreamsAI.png";

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    const session = JSON.parse(sessionStorage.getItem("admin_session")) ?? {};

    // Phone numbers — JSP keys; may be added to session later
    const compamyPhone1 = session.compamyPhone1 ?? session.wholesale_customercarePhone1 ?? "";
    const compamyPhone2 = session.compamyPhone2 ?? session.wholesale_customercarePhone2 ?? "";

    // Company name — company_name already exists in session (equivalent to compamyName)
    const compamyName = session.companyName ?? session.wholesale_companyname ?? "";

    // Company logo — company_logo already exists in session (equivalent to compamyLogo)
    const compamyLogo = session.compamyLogo ?? session.company_logo ?? session.wholesale_logo ?? "";

    // Footer text — may be added to session later
    const footerText = session.footerText ?? session.wholesale_footertext ?? "";

    // Product name: if streamRequestFor is truthy → productname, else → streams_productname
    const streamRequestFor = session.streamRequestFor;
    const productName = streamRequestFor
        ? (session.productname ?? "")
        : (session.streams_productname ?? session.productname ?? "");

    const themeBasedLogo = localStorage.getItem("selectedColorTheme");

    return (
        <>
            <div style={{ background: '#e2e8f0' }} className="py-5">
                <MDBRow className="justify-content-center">
                    <MDBCol md={6}>
                        <div>
                        <MDBCard className="p-0  overflow-hidden rounded-7" >
                                <MDBCardHeader className="d-flex align-items-center justify-content-between shadow-2 px-4 bg-light border-bottom">
                                    {/* <img
                                        src={themeBasedLogo === "dark" ? Logo : LogoDark}
                                        className="logo"
                                        alt={productName}
                                        style={{ height: "45px", width: "auto" }}
                                    /> */}
                                    {compamyLogo ? (
                                        // <div className="mb-4">
                                            <img
                                                src={compamyLogo}
                                                alt={compamyName}
                                                style={{ height: "45px", width: "auto" }}
                                                // onError={(e) => { e.target.style.display = "none"; }}
                                            />
                                        // </div>
                                    ) : (
                                        <img
                                            src={themeBasedLogo === "dark" ? Logo : LogoDark}
                                            className="logo"
                                            alt={productName}
                                            style={{ height: "45px", width: "auto" }}
                                        />
                                    )}
                                    {(compamyPhone1 || compamyPhone2) && (
                                        <strong>
                                            {t("reachUsAt")}{" "}
                                            <span>
                                                {compamyPhone1}
                                                {compamyPhone1 && compamyPhone2 ? " or " : ""}
                                                {compamyPhone2}
                                            </span>
                                        </strong>
                                    )}
                                </MDBCardHeader>
                                <MDBCardBody className="privacy-container p-0" >
                                <MDBContainer className="p-5 pt-3">
                                   

                                    <h2 className="mb-4 text-center">{t("privacypolicy")}</h2>

                                    <div>
                                        <p>
                                            <strong>{compamyName}</strong> {t("privacypolicy_tooltip1")}
                                        </p>
                                        <div className="pt-4">
                                            <div className="mb-4" >
                                                <div className="d-flex align-items-center">
                                                    <span className="pe-2 " style={{borderLeft:'3px solid #3b71ca',  height:'17px'}}></span>
                                                    <p dangerouslySetInnerHTML={{ __html: t("pricacy_titel1") }} className="fw-bold  text-primary" />
                                                </div>
                                                <p dangerouslySetInnerHTML={{ __html: t("privacypolicy_tooltip2") }} className="ps-3"   />
                                            </div>
                                            <div className="mb-4" >
                                                 <div className="d-flex align-items-center">
                                                    <span className="pe-2 " style={{borderLeft:'3px solid #3b71ca', height:'17px'}}></span>
                                                <p dangerouslySetInnerHTML={{ __html: t("pricacy_titel2") }} className="fw-bold text-primary" />
                                                </div>
                                                <p dangerouslySetInnerHTML={{ __html: t("privacypolicy_tooltip3") }} className="ps-3"  />
                                            </div>
                                            <div className="mb-4" >
                                                 <div className="d-flex align-items-center">
                                                    <span className="pe-2 " style={{borderLeft:'3px solid #3b71ca', height:'17px'}}></span>
                                                <p dangerouslySetInnerHTML={{ __html: t("pricacy_titel3") }} className="fw-bold text-primary" />
                                                </div>
                                                <p dangerouslySetInnerHTML={{ __html: t("privacypolicy_tooltip4") }} className="ps-3" />
                                            </div>


                                        </div>
                                    </div>
                                </MDBContainer>
                            </MDBCardBody>
                        </MDBCard>
                        </div>
                          <div className=" py-2 text-center text-muted ">
                                    <small>{footerText}</small>
                          </div>
                    </MDBCol>
                </MDBRow>
            </div>
        </>
    );
};

export default PrivacyPolicy;
